export var WriterError = /*#__PURE__*/ function(WriterError) {
    WriterError["GifCountExceeded"] = "gif count exceeded";
    WriterError["EmoteCountExceeded"] = "emote count exceeded";
    WriterError["ImageCountExceeded"] = "image count exceeded";
    WriterError["MentionCountExceeded"] = "mention count exceeded";
    WriterError["ContentTooLong"] = "content too long";
    WriterError["Unspecified"] = "error unspecified";
    WriterError["Spam"] = "System thinks this is spam.";
    return WriterError;
}({});
export var WriterPopupType = /*#__PURE__*/ function(WriterPopupType) {
    WriterPopupType["JOURNAL"] = "JOURNAL";
    WriterPopupType["LITERATURE"] = "LITERATURE";
    return WriterPopupType;
}({});

//# sourceMappingURL=types.js.map